import {
  Component,
  forwardRef,
  Inject,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from '@angular/core';

import {
  BlockUI,
  NgBlockUI
} from 'ng-block-ui';

import { HaynesProService }        from '../haynes-pro.service';
import { HaynesProSubGroupModel }  from '../typings/haynes-pro.sub-group';
import { MessagesService }         from '../../messages/messages.service';
import { VehicleModel }            from '../../vehicles/models/vehicle';
import { HaynesProLubricantModel } from '../typings/haynes-pro.lubricant';

@Component({
  selector   : 'wor-haynes-pro-diagnostic-tool-lubricants',
  template: require('./haynes-pro.diagnostic-tool.lubricants.component.html')
})
export class HaynesProDiagnosticToolLubricantsComponent implements OnChanges, OnInit {

  @BlockUI('haynesProLubricantsBlock') block : NgBlockUI;

  @Input() isActive  : boolean;
  @Input() subGroups : Array<HaynesProSubGroupModel>;
  @Input() vehicle   : VehicleModel;

  lubricants : Array<HaynesProLubricantModel> = [];
  subGroup   : HaynesProSubGroupModel;

  constructor (
    @Inject(forwardRef(() => HaynesProService))
    private haynesProService : HaynesProService,
    @Inject(forwardRef(() => MessagesService)) private messagesService  : MessagesService
  ) {}

  ngOnChanges ( changes : SimpleChanges ) : void {
    if ( changes.isActive && !changes.isActive.isFirstChange() && changes.isActive.currentValue ) {
      const subGroup = this.subGroup
        ? this.subGroup
        : this.subGroups[0];

      subGroup.selected = true;
    }
  }

  ngOnInit () : void {
    if (this.isActive) {
      this.subGroups[0].selected = true;
    }
  }

  handleSubGroupSelection ( subGroup : HaynesProSubGroupModel ) : void {
    this.block.start();

    this.lubricants = [];
    this.subGroup   = subGroup;

    this.haynesProService.getLubricants(this.vehicle, subGroup.name)
    .then(( lubricants : Array<HaynesProLubricantModel> ) => {
      this.lubricants = lubricants;

      if ( !this.isActive ){
        this.haynesProService.updateSubscriptionStatus(true);
      }
    })
    .catch(( err ) => {
      this.messagesService.error(err);
    })
    .finally(() => {
      this.block.stop();
    });
  }

}